import React from 'react';
import { StackElement } from './stack.styles.js';
export const Stack = React.forwardRef(({ direction = 'column', ...props }, ref) => (React.createElement(StackElement, { direction: direction, ...props, ref: ref })));
//# sourceMappingURL=stack.component.js.map